<template>
  <div class="button-common">
    <button
      @click="handle"
      :style="{
        height: height,
        width: width,
      }"
      :class="[type]"
      :disabled="disabled"
    >
      <svg width="24px" height="24px" viewBox="0 0 24 24" v-if="loading">
        <g
          id="body/loading"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="icons/body/loading">
            <circle
              id="椭圆形"
              stroke="#000"
              stroke-width="3"
              cx="12"
              cy="12"
              r="10.5"
            ></circle>
            <circle id="椭圆形" fill="#0552DC" cx="12" cy="6" r="3"></circle>
            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="rotate"
              dur="1s"
              from="0 12 12"
              to="360 12 12"
              repeatCount="indefinite"
            />
          </g>
        </g>
      </svg>
      <slot v-else></slot>
      <div class="c-button-ripple">
        <div
          class="c-button-ripple-item"
          :style="{ left: rippleX + 'px', top: rippleY + 'px' }"
          v-for="item of ripple"
          :key="item"
        ></div>
      </div>
    </button>
  </div>
</template>
<script>
export default {
  name: "buttons",
  data() {
    return {
      ripple: [],
      rippleX: "",
      rippleY: "",
    };
  },
  props: {
    disabled: {
      type: Boolean, //default
      default: false,
    },
    type: {
      type: String, //default
      default: "default",
    },
    height: {
      type: String,
      default: "40px",
    },
    width: {
      type: String,
      default: "240px",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handle(e) {
      // this.$emit("click");
      if (this.disabled) {
        return;
      }
      this.$emit("click");
      const btnInfo = this.$el.getBoundingClientRect();
      this.rippleX = e.clientX - btnInfo.left;
      this.rippleY = e.clientY - btnInfo.top;
      this.ripple.push(new Date().getTime());
      // setTimeout(() => {
      //   this.ripple.shift();
      // }, 500);
    },
  },
};
</script>
<style lang="scss" scoped>
.button-common {
  width: 100%;
  height: 100%;
  cursor: pointer;
  button {
    position: relative;
    width: 100%;
    height: 100%;
    // padding-left: 32px;
    // padding-right: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
    box-sizing: border-box;
    border: 1px solid transparent;
    background-color: transparent;
    backface-visibility: hidden; // 防止文字抖动
    border-radius: 28px;
    .c-button-ripple {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: 28px;
      .c-button-ripple-item {
        position: absolute;
        width: 100%;
        padding-top: 100%;
        border-radius: 50%;
        background-color: #f6f8ff;
        transform: translate(-50%, -50%) scale(0.01);
        opacity: 0;
        animation: ripple 0.5s ease-in;
      }
    }
    &.defaultOriginal {
      background-color: $lighten-color;
      border-radius: 0px;
      color: #000000;
      &:not(:disabled):hover {
        background: #a6f616;
      }
    }
    &.default {
      background-color: $lighten-color;
      color: #000000;
      &:not(:disabled):hover {
        background: #a6f616;
      }
    }
    &.success {
      background-color: $lighten-success-color;
      color: $lighten-color !important;
    }
    &.error {
      background-color: $lighten-error-color;
      color: $lighten-color !important;
    }
    &.info {
      background-color: colorRgba($lighten-color, 0.1);
      color: $lighten-color;
    }

    &.blueGradient {
      background-image: linear-gradient(
        45deg,
        #1d97c7 0%,
        #5178f0 53%,
        #875ff3 100%
      );
      color: $lighten-color;
    }

    &.marginXBridge {
      background-image: linear-gradient(90deg, #18eed8 1%, #a6f616 100%);
      border-radius: 22px;
    }

    &.withdrawMin {
      background: #101314;
      border-radius: 28px;
      color: #ffffff;
    }
    &.infoMin {
      background: #a6f616;
      border-radius: 28px;
    }
    &.transferMin {
      background: #ffffff;
      border-radius: 28px;
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
      color: initial;
    }

    &:not(:disabled):hover {
      opacity: 0.8;
    }

    &.linkBorder {
      background: rgba(255, 255, 255, 0);
      border: 1px solid rgba(255, 255, 255, 1);
      border-radius: 24px;
      color: #ffffff;
    }

    &.linearGradientBorder {
      border: 2px solid transparent;
      border-radius: 28px;
      background-clip: padding-box, border-box;
      background-origin: padding-box, border-box;
      background-image: linear-gradient(to right, #3a3c44, #3a3c44),
        linear-gradient(360deg, #18eed8, #a6f616);
    }

    &.transfer {
      background: #ffffff;
      border-radius: 28px;
      &:disabled {
        background: #595a5b;
        opacity: 1;
        cursor: not-allowed;
      }

      &:not(:disabled):hover {
        background: #a6f616;
      }
    }
  }
}

@keyframes ripple {
  25% {
    opacity: 0.07;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}
</style>
